import { render } from "./OrganisationChooser.vue?vue&type=template&id=0e48dd0c"
import script from "./OrganisationChooser.vue?vue&type=script&lang=js"
export * from "./OrganisationChooser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__